export const tileNames: string[] = [
  '쇠', '귀', '려', '뢰', '쥬', '휴', '슈',
]